import { Camera } from "lucide-react";

const GALLERY_ITEMS = [
  {
    img: "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    title: "Instalação Split Residencial",
    category: "Ar Condicionado",
  },
  {
    img: "https://images.unsplash.com/photo-1617861648989-76a572012089?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    title: "Manutenção Preventiva",
    category: "Manutenção",
  },
  {
    img: "https://images.unsplash.com/photo-1729183672500-46c52a897de5?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    title: "Instalação Comercial",
    category: "Ar Condicionado",
  },
  {
    img: "/assets/img/instalacao-camara.jpg",
    title: "Câmara Fria Industrial",
    category: "Câmara Fria",
  },
  {
    img: "/assets/img/sistema-chiller.jpg",
    title: "Sistema Chiller",
    category: "Industrial",
  },
  {
    img: "https://images.unsplash.com/photo-1622787066476-2794c60844d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    title: "Projeto Completo",
    category: "Ar Condicionado",
  },
];

export default function Gallery() {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#E0F2FE] text-[#0E86D4] text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 font-['Barlow_Condensed']">
            Portfólio
          </span>
          <h2
            data-testid="gallery-title"
            className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight"
          >
            Nossos Trabalhos
          </h2>
          <p className="mt-4 text-base text-[#64748B] max-w-xl mx-auto font-['Manrope']">
            Confira alguns dos nossos projetos e serviços realizados em Goiânia e região.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {GALLERY_ITEMS.map((item, idx) => (
            <div
              key={item.title}
              data-testid={`gallery-item-${idx}`}
              className="gallery-item rounded-sm h-64"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="gallery-overlay absolute inset-0 bg-[#0E86D4]/80 flex flex-col items-center justify-center text-white p-4">
                <Camera className="w-8 h-8 mb-3" />
                <h3 className="text-lg font-bold font-['Barlow_Condensed'] uppercase tracking-tight text-center">
                  {item.title}
                </h3>
                <span className="text-xs font-medium mt-1 bg-white/20 px-3 py-1 rounded-sm font-['Manrope']">
                  {item.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
